module.exports = __webpack_public_path__ + "static/home_scopri1-2063e0a8665cb730f85de3e2fb4cb7c8.jpg";